import { Material, Size, Addon, Photo } from "pages/product-management/ProductType";
import axiosClient from "./axios";
import { SearchProductParams } from "pages/product-management/ProductManagement";

type CreateCategory = {
  name: string;
  code: string;
  description: string;
}

type UpdateCategory = {
  id: number;
} & CreateCategory;

type CreateProduct = {
  name: string;
  description: string;
  basePrice: number;
  categoryIds: number[];
  sizes: Size[];
  materials: Material[];
  photos: Photo[];
  addons: Addon[];
}

type UpdateProduct = {
  id: number;
} & CreateProduct;

export const getCategories = async (page: number, pageSize: number) => {
  const response = await axiosClient.get('/product/category/all', {
    params: {
      page,
      pageSize,
    },
  });
  return response.data;
};

export const createCategory = async (category: CreateCategory) => {
  const response = await axiosClient.post('/product/category', category);
  return response.data;
};

export const updateCategory = async (category: UpdateCategory) => {
  const response = await axiosClient.put(`/product/category/${category.id}`, category);
  return response.data;
};

export const deleteCategory = async (id: number) => {
  const response = await axiosClient.delete(`/product/category/${id}`);
  return response.data;
};

export const getProducts = async (page: number, pageSize: number, params: SearchProductParams) => {
  const response = await axiosClient.get('/product/all', {
    params: {
      page,
      pageSize,
      search: params.search,
      category: params.category,
    },
  });
  return response.data;
};

export const createProduct = async (product: CreateProduct) => {
  const response = await axiosClient.post('/product', product);
  return response.data;
};

export const updateProduct = async (product: UpdateProduct) => {
  const response = await axiosClient.put(`/product/${product.id}`, product);
  return response.data;
};

export const deleteProduct = async (id: number) => {
  const response = await axiosClient.delete(`/product/${id}`);
  return response.data;
};

export const getCategorieOptions = async () => {
  const response = await axiosClient.get('/product-option/categories');
  return response.data;
};

export const getSizeOptions = async () => {
  const response = await axiosClient.get('/product-option/sizes');
  return response.data;
};

export const getMaterialOptions = async () => {
  const response = await axiosClient.get('/product-option/materials');
  return response.data;
};

export const getAddonOptions = async () => {
  const response = await axiosClient.get('/product-option/addons');
  return response.data;
};